import { all, takeLeading } from 'redux-saga/effects';

import { onErrorPlanning, onSuccessPlanning } from '../slice';
import { onErrorPlanningSaga, onSuccessPlanningSaga } from './plan-call';

/**
 *
 */
export default function* (): Generator {
    yield all([
        takeLeading(onSuccessPlanning.type, onSuccessPlanningSaga),
        takeLeading(onErrorPlanning.type, onErrorPlanningSaga),
    ]);
}
